import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAzureReposLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 71,
	height: 71,
	viewBox: "8.4375 8.4375 54 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M50.2309 8.43824H22.0428C20.9556 8.43824 20.0818 9.31274 20.0818 10.4V16.8219H52.1927V10.3992C52.1927 9.31201 51.3181 8.4375 50.2309 8.4375",
			fill: "#BC3618"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.5506 12.3632H18.7279C17.1585 12.3632 15.8923 13.63 15.8923 15.1987V17.4291H56.3868V15.1987C56.3868 13.6293 55.12 12.3632 53.5513 12.3632",
			fill: "#D13816"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.6299 16.3845H14.648C13.0786 16.3845 11.8125 17.6514 11.8125 19.22V59.5909C11.8125 61.1603 13.0904 62.4374 14.6591 62.4374H57.6188C59.1882 62.4374 60.4654 61.1595 60.4654 59.5909V19.2208C60.4654 17.6514 59.1985 16.3853 57.6299 16.3853",
			fill: "#E15A17"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.169 20.5443C23.1877 20.5443 20.7666 22.9654 20.7666 25.9467C20.7666 28.9279 23.1877 31.349 26.169 31.349C29.1502 31.349 31.5713 28.9279 31.5713 25.9467C31.5713 22.9654 29.1502 20.5443 26.169 20.5443ZM26.169 29.4432C24.23 29.4432 22.6606 27.8738 22.6606 25.9349C22.6606 23.996 24.23 22.4273 26.169 22.4273C28.1079 22.4273 29.6773 23.9967 29.6773 25.9349C29.6773 27.8731 28.1079 29.4432 26.169 29.4432Z",
			fill: "#F7B192"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.1976 30.7625H24.196V41.7129H28.1976V30.7625Z",
			fill: "#F7B192"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.8262 26.0211C51.8262 23.0399 49.4051 20.6188 46.4239 20.6188C43.4426 20.6188 41.0215 23.0399 41.0215 26.0211C41.0215 28.3186 42.4562 30.2803 44.4849 31.065V34.775L24.199 41.4774H24.1652V48.3475C22.1813 49.1433 20.7805 51.0933 20.7805 53.3576C20.7805 56.3388 23.2016 58.7599 26.1829 58.7599C29.1641 58.7599 31.5852 56.3388 31.5852 53.3576C31.5852 51.1161 30.2175 49.1882 28.2786 48.3696V44.1105L48.4526 37.442L48.4077 37.3632H48.4526V31.0194C50.4254 30.2236 51.8262 28.2847 51.8262 26.0204M29.6794 53.3679C29.6794 55.3068 28.11 56.8762 26.1711 56.8762C24.2322 56.8762 22.6628 55.3068 22.6628 53.3679C22.6628 51.4289 24.2322 49.8595 26.1711 49.8595C28.11 49.8595 29.6794 51.4289 29.6794 53.3679ZM46.4239 29.5177C44.4849 29.5177 42.9155 27.9483 42.9155 26.0094C42.9155 24.0704 44.4849 22.5018 46.4239 22.5018C48.3628 22.5018 49.9322 24.0712 49.9322 26.0094C49.9322 27.9476 48.3518 29.5177 46.4239 29.5177Z",
			fill: "#FCDACB"
		})
	]
});
const ForwardRef = forwardRef(SvgAzureReposLogo);
export { ForwardRef as ReactComponent };
